import React, { useEffect } from "react";
import { Grid, Button, InputAdornment, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { FaVideo, FaImage, FaFile } from "react-icons/fa";

import HeaderButtons from "./HeaderButtons";
import "../../whatsapp interface/WhatsappPreview.css";

import {
  ComponentHeader,
  Paper,
  TextField,
  Label,
} from "../../../../components";

const mediaContainerStyle = {
  height: 220,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
};

export default function TemplateHeader({ formikProps, addSample }) {
  const handleAddVariable = () => {
    var textHeader = document.getElementsByName("templateHeader.text")[0].value;
    var count_var_1 = (textHeader.match(/\{{/g) || []).length;
    var count_var_2 = (textHeader.match(/\}}/g) || []).length;

    if (count_var_1 === 0 && count_var_2 === 0) {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        templateHeader: setVariables(prevVal.templateHeader),
      }));
      function setVariables(templateHeader) {
        templateHeader.text = textHeader + "{{1}}";
        templateHeader.count_of_variable = 1;
        return templateHeader;
      }
    }
  };

  const mediaUrl =
    formikProps.values?.templateHeader?.example?.[0] === "string"
      ? formikProps.values?.templateHeader?.example?.[0]
      : formikProps.values?.templateHeader?.example?.[0]?.url;

  console.log(
    "media url",
    formikProps.values.templateHeader?.example?.[0]?.url
  );

  const handleHeaderChange = (event) => {
    var textHeader = document.getElementsByName("templateHeader.text")[0].value;
    var count_var_1 = (textHeader.match(/\{{/g) || []).length;

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateHeader: setVariables(prevVal.templateHeader),
    }));

    function setVariables(templateHeader) {
      templateHeader.text = event.target.value;
      templateHeader.count_of_variable = count_var_1 === 0 ? 0 : count_var_1;
      return templateHeader;
    }
  };

  return (
    <Paper>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Template Header"}
          buttons={[
            <HeaderButtons formikProps={formikProps} addSample={addSample} />,
          ]}
        />

        <Typography
          variant="subtitle2"
          gutterBottom
          style={{ color: "#808080b3" }}
        >
          Add a title or choose which type of media you'll use for this header.
        </Typography>
      </Grid>

      {formikProps.values?.templateHeader?.type === "text" && (
        <React.Fragment>
          <Grid item xs={12}>
            <Label title="Header Text" />

            <TextField
              placeholder="Header Text"
              name="templateHeader.text"
              formikProps={formikProps}
              onChange={handleHeaderChange}
              disabled={
                Boolean(formikProps.values.ID) ||
                Boolean(addSample) ||
                formikProps.isSubmitting
              }
              inputProps={{
                maxLength: 60,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {formikProps.values?.templateHeader?.text?.length}/60
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={9} />

          <Grid textAlign={"end"} item xs={3}>
            <Button
              variant="outlined"
              color="primary"
              disabled={
                Boolean(addSample) ||
                Boolean(formikProps.values.ID) ||
                formikProps.isSubmitting
              }
              onClick={handleAddVariable}
              startIcon={<Add />}
            >
              Add Variable
            </Button>
          </Grid>
        </React.Fragment>
      )}

      {formikProps.values?.templateHeader?.type === "image" && (
        <Grid item xs={12}>
          <div
            align="center"
            className="HeaderType"
            style={{
              ...mediaContainerStyle,
              width: 350, // or "60%", "400px"
              maxWidth: "100%",
            }}
          >
            {mediaUrl ? (
              <img
                src={mediaUrl}
                alt="Header Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: 200,
                  objectFit: "contain",
                  borderRadius: 8,
                }}
              />
            ) : (
              <FaImage />
            )}
          </div>
        </Grid>
      )}

      {formikProps.values?.templateHeader?.type === "video" && (
        <Grid item xs={12}>
          <div
            align="center"
            className="HeaderType"
            style={{
              ...mediaContainerStyle,
              width: 350, // or "60%", "400px"
              maxWidth: "100%",
            }}
          >
            {mediaUrl ? (
              <video
                controls
                style={{
                  maxWidth: "100%",
                  maxHeight: 200,
                  borderRadius: 8,
                }}
              >
                <source src={mediaUrl} />
              </video>
            ) : (
              <FaVideo />
            )}
          </div>
        </Grid>
      )}

      {formikProps.values?.templateHeader?.type === "document" && (
        <Grid item xs={12}>
          <div
            className="HeaderType"
            style={{
              ...mediaContainerStyle,
              width: 350, // or "60%", "400px"
              maxWidth: "100%",
            }}
          >
            <FaFile
              style={{
                fontSize: 100,
                color: "#6a1b9a",
              }}
            />
            {mediaUrl && (
              <a
                href={mediaUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                Open Document
              </a>
            )}
          </div>
        </Grid>
      )}
    </Paper>
  );
}
